import { CHECPLUS_CAN_OUTPUT_IDS } from 'utils/constants'

export const canOutputId = (featureModuleName, numberOfBits) =>
  CHECPLUS_CAN_OUTPUT_IDS[featureModuleName][numberOfBits]
